import { StateCreator } from 'zustand';

export interface AppConfigSlice {
  token: any;
  adminInfo: any | null;
  updateStateValue: (key: string, value: any) => void;
  updateToken: (token: any) => void;
}

export const createAppConfigSlice: StateCreator<AppConfigSlice> = (set) => ({
  token: null,
  adminInfo: null,

  updateToken: async (tk: any) => {
    set(() => ({ token: tk }));
  },
  updateStateValue: async (key: string, value: any) => {
    set(() => ({ [key]: value }));
  },
});
